import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { withRouter } from "react-router-dom";

class CarouselNewArrival extends Component {
  handleBook = (bookId) => {
    this.props.history.push(`/books/details/${bookId}`);
  };

  render() {
    const { newArrival, slidesPerScroll, imageWidth } = this.props;
    return (
      <Carousel
        infinite
        dots
        slides={newArrival.length}
        slidesPerPage={slidesPerScroll}
        slidesPerScroll={1}
        clickToChange
        itemWidth={imageWidth}
        animationSpeed={1500}
        autoPlay={3000}
        stopAutoPlayOnHover
        arrowLeft={
          <IconButton>
            <ArrowBackIosIcon />
          </IconButton>
        }
        arrowRight={
          <IconButton>
            <ArrowForwardIosIcon />
          </IconButton>
        }
        addArrowClickHandler
      >
        {newArrival.map((book, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              "&:hover": {
                opacity: 0.6,
              },
            }}
            onClick={() => this.handleBook(book._id)}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <img
                src={book.bookCoverUrl}
                alt="BookCoverImage"
                style={{ width: 200, height: 250 }}
              />
              <div
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {book.title}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    );
  }
}

export default withRouter(CarouselNewArrival);
